/**
 * Default main-level hook (fires on window load, after page-type hooks).
 * No-op by default.
 *
 * Override in projects/<id>/ui/hooks/onMainInit.ts to add project-specific
 * logic that should run after all page hooks have completed.
 *
 * @example
 * // projects/myproject/ui/hooks/onMainInit.ts
 * import type { MainContext } from '@core/types/hooks';
 * export default async function onMainInit(context: MainContext): Promise<void> {
 *     trackPageView(context.pageType);
 * }
 */
export default async function onMainInit(_context) {
    // no-op — override per project
}
